module.exports = __webpack_public_path__ + "static/media/grid-img1.58f52775.svg";